import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P21-E1',
    audio: 'img/FriendsPlus/Page20/Audio/audio-e2-p20.mp3',
    video: 'Videos/e2.p20.mp4',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E1/1.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh1-e2-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh2-e2-p20.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page20/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh3-e2-p20.mp3' },
        { url: 'img/FriendsPlus/Page20/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page20/Audio/hinh4-e2-p20.mp3' },
      ],



    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P21-E2',
    audio: 'img/FriendsPlus/Page21/Audio/audio-e2-p21.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/tieude-e2-p21.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page21/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page21/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/doan1.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page21/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page21/Audio/doan2.mp3' },
        { url: 'img/FriendsPlus/Page21/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page21/E2/11.jpg' },
      ],



    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P21-E3',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page21/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page21/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page21/E3/3.jpg', input: true, answer: "Their" },//3
        { url: 'img/FriendsPlus/Page21/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page21/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page21/E3/6.jpg', input: true, answer: "Our" },//4
        { url: 'img/FriendsPlus/Page21/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page21/E3/8.jpg', input: true, answer: "your" },//5
        { url: 'img/FriendsPlus/Page21/E3/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page21/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page21/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page21/E3/12.jpg', input: true, answer: "our" },//2
        { url: 'img/FriendsPlus/Page21/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page21/E3/14.jpg', input: true, answer: "their" },//6
        { url: 'img/FriendsPlus/Page21/E3/15.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page21/E3/16.jpg' },
      ],

    ],
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P21-E4',
    audio: '',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page21/E4/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page21/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page21/E4/3.jpg', input: true, answer: "No, you can't" },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page21/E4/4.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page21/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page21/E4/6.jpg', input: true, answer: "No, you can't" },
        { url: 'img/FriendsPlus/Page21/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page21/E4/8.jpg', input: true, answer: "Yes, you can" },
      ],


    ],
  },
  5: { // Exercise num
    unit: 'Unit 3',
    id: 'SB4-U3-P21-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E5/1.jpg' },
      ],

    ],
  },

}

export default json;